import React from 'react';
import TaskIcon from '../tasks/TaskIcon';
import { Folding } from './useCollapsed';

/** "Expand all" / "Collapse all" icon pair, shared by the map and the Gantt chart. */
const FoldButtons: React.FC<{ fold: Folding; onChange?: () => void }> = ({ fold, onChange }) => (
  <span className="tp-fold-buttons" role="group" aria-label="Expand or collapse">
    <button
      type="button"
      className="tk-icon-btn"
      onClick={() => {
        fold.expandAll();
        onChange?.();
      }}
      disabled={!fold.anyCollapsed}
      aria-label="Expand all"
      title="Expand all"
    >
      <TaskIcon name="expand-all" size={16} />
    </button>
    <button
      type="button"
      className="tk-icon-btn"
      onClick={() => {
        fold.collapseAll();
        onChange?.();
      }}
      disabled={fold.allCollapsed}
      aria-label="Collapse all"
      title="Collapse all"
    >
      <TaskIcon name="collapse-all" size={16} />
    </button>
  </span>
);

export default FoldButtons;
